import { useCallback, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { fetchEditOrder } from 'requests/order'
import { addHttpError } from 'store/http-error/http-error.actions'
import { setInitialValuesOrderRead } from 'store/order/order.actions'
import { selectOrderRead } from 'store/order/order.selectors'
import { selectToken } from 'store/users/users.selectors'
import { OrderFields, OrderTypeId } from 'types/order'
import { Feature } from 'types/user'

export const useMandatoryDlCheck = () => {
  const dispatch = useDispatch()
  const token = useSelector(selectToken)
  const orderFields = useSelector(selectOrderRead)
  const [isLoading, setIsLoading] = useState(false)

  const mandatoryDLCheck = orderFields[OrderFields.CUSTOMER_FEATURES]?.[Feature.MANDATORY_DL_CHECK] === true
  const hasDriverDoc = Boolean(orderFields[OrderFields.DRIVER_DOC]?.trim())
  const isEmployeeOrder = String(orderFields[OrderFields.ORDER_TYPE]) === OrderTypeId.EMPLOYEE

  const isVisible = mandatoryDLCheck && hasDriverDoc && !isEmployeeOrder
  const isDriverDocValid = orderFields[OrderFields.IS_DRIVER_DOC_VALID]
  const isChecked = isDriverDocValid !== null
  const isValid = isDriverDocValid === true
  const isInvalid = isDriverDocValid === false

  const setDriverDocValid = useCallback(
    async (value: boolean) => {
      if (isDriverDocValid === value) return

      setIsLoading(true)
      try {
        await fetchEditOrder(
          {
            [OrderFields.ORDER_NUMBER]: orderFields[OrderFields.ORDER_NUMBER],
            fields: { [OrderFields.IS_DRIVER_DOC_VALID]: value },
          },
          token!,
        )
        dispatch(
          setInitialValuesOrderRead({
            ...orderFields,
            [OrderFields.IS_DRIVER_DOC_VALID]: value,
          }),
        )
      } catch (error) {
        dispatch(addHttpError({ error, header: 'Проверка ВУ', defaultText: 'Не удалось сохранить статус водительского удостоверения.' }))
      } finally {
        setIsLoading(false)
      }
    },
    [dispatch, isDriverDocValid, orderFields, token],
  )

  return useMemo(
    () => ({
      isVisible,
      isChecked,
      isValid,
      isInvalid,
      isDriverDocValid,
      mandatoryDLCheck,
      isLoading,
      setDriverDocValid,
    }),
    [isVisible, isChecked, isValid, isInvalid, isDriverDocValid, mandatoryDLCheck, isLoading, setDriverDocValid],
  )
}
